import { init, getClient } from '@coretek/aperture-sdk';
import type { ApertureClient } from '@coretek/aperture-sdk';

let client: ApertureClient | null = null;

export function initAperture(): ApertureClient {
  if (client) return client;

  client = init({
    apiKey: import.meta.env.VITE_APERTURE_KEY ?? '',
    apiHost:
      import.meta.env.VITE_APERTURE_HOST ??
      'https://ca-aperture-dev-api.greenbay-fa050047.eastus2.azurecontainerapps.io',
    autocapture: true,
    recording: true,
    debug: import.meta.env.DEV,
  });

  return client;
}

export { getClient };
